import { createContext, useContext } from 'react';

export type FormData = Record<string, unknown>;

export interface FormContextValue {
  formDataContext: FormData;
  updateFormData: (newFormData: { name: string; value: unknown }) => void;
}

export const FormContext = createContext<FormContextValue | null>(null);

export const useFormContext = (): FormContextValue => {
  const context = useContext(FormContext);
  if (context === null) {
    throw new Error('useFormContext must be used within a FormContextProvider');
  }
  return context;
};
